import { useEffect, useState, type ReactElement, type ReactNode } from "react";

/**
 * PREVIEW_MODE demo guard — any loading placeholder that takes longer than
 * `ms` to resolve is force-hidden so the UI never shows a spinner for more
 * than 2 seconds during the private Final preview. Returns `true` while the
 * placeholder is allowed to render, `false` after the timeout elapses.
 */
export function useVisibleFor(ms = 2000): boolean {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const id = window.setTimeout(() => setVisible(false), ms);
    return () => window.clearTimeout(id);
  }, [ms]);
  return visible;
}

export function AutoHide({ ms = 2000, children }: { ms?: number; children: ReactNode }): ReactElement | null {
  const visible = useVisibleFor(ms);
  if (!visible) return null;
  return children as ReactElement;
}